import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { profileData } from "../data/profileData";

const Education = () => {
	const { ref, inView } = useScrollAnimation();

	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: { staggerChildren: 0.15 },
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 20 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.5 },
		},
	};

	return (
		<section id="education" className="section-card" ref={ref}>
			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={containerVariants}
			>
				<motion.div className="section-header" variants={itemVariants}>
					<span>Education</span>
					<h2>Academic background</h2>
				</motion.div>
				<motion.div className="education-grid" variants={containerVariants}>
					{profileData.education.map((item) => (
						<motion.div
							key={item.degree}
							className="education-item"
							variants={itemVariants}
						>
							<h3>{item.degree}</h3>
							<p className="education-institution">{item.institution}</p>
							<span className="education-range">{item.range}</span>
							<p className="education-note">{item.note}</p>
						</motion.div>
					))}
				</motion.div>
			</motion.div>
		</section>
	);
};

export default Education;
